module.exports = __webpack_public_path__ + "static/img/hal_avatar.51dac2e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/chat/hal_avatar.svg
// module id = JHJL
// module chunks = 35